<script>
    // расставить по возрастанию

    import {flip} from 'svelte/animate';
    import {dndzone} from 'svelte-dnd-action';

    export let wrapper;
    export let data;
    export let reward;
    const check = () => {
        let result = true;
    
        [...items].sort((a, b) => a.value - b.value).forEach((el, i) => {
            result = result && el.id === items[i].id;
        });
    
        reward(result);
    };
    
    let items = data ? data.options.map((el, i) => { return {id: i, ...el} }) : [];
    const flipDurationMs = 300;
    const handleDndConsider = (e) => {
        items = e.detail.items;
    }
    const handleDndFinalize = (e) => {
        items = e.detail.items;
    
        [...items].sort((a, b) => a.value - b.value).forEach((el, i) => {
            if (el.id === items[i].id) {
                wrapper.querySelector('[data-id="'+el.id+'"]').classList.add('list-group-item-success');
            } else {
                wrapper.querySelector('[data-id="'+el.id+'"]').classList.remove('list-group-item-success');
            }
        });
    }
</script>

<div class="list-group text-center" use:dndzone={{items, flipDurationMs}} on:consider={handleDndConsider} on:finalize={handleDndFinalize}>
    {#each items as item(item.id)}
        <div class="list-group-item" data-id="{item.id}" animate:flip="{{duration: flipDurationMs}}">
            {item.label}
        </div>
    {/each}
</div>

<div class="row mt-3">
    <div class="col-12">
        <button type="button" class="btn btn-primary btn-block btn-lg" on:click={check}>Готово</button>
    </div>
</div>
